export enum PrimatooManageEntity{
	WORKSPACE = 'WORKSPACE',
  DATABREACH = 'DATABREACH',
	NONE = 'NONE',
}
